import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglechatComponent } from './simple-icons-googlechat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglechatComponent ],
    exports:      [ SimpleIconsGooglechatComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglechatModule {}
